import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import CloneableInputGroup from 'library/components/cloneable-input-group';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';
import Toggle from 'library/components/form-elements/toggle';
import Tag from 'library/components/tag';

const CertificationsFields = ({ className='', data, onChange, baseKey = '', index, active=false }) => {
    const Years = [...Array(100).keys()].map(n=><option key={2017 - n} value={2017 - n}>{2017 - n}</option>);

    const remove = () => {
        onChange(new SyntheticEvent({
            name: baseKey,
            value: undefined,
            type: 'object'
        }));
    }

    const handleChangeDate = (e) => {
        const { name, value } = e.target;
        const [ key, type ] = name.split('_');

        let [ year, month, day='01' ] = (resolve(data, `date_range.${key}`, '--1', '.') || '').split('-').map(v=>v||'');

        if (type === 'month') {
            month = value;
        } else if (type === 'year') {
            year = value;
        }

        onChange(new SyntheticEvent({
            name: `${baseKey}.date_range.${key}`,
            value: `${year}-${month}-01`
        }))
    }

    let [start_year='',start_month=''] = (resolve(data, 'date_range.start', '--1', '.') || '').split('-').map(v=>v||'');

    let [finish_year='',finish_month=''] = (resolve(data, 'date_range.finish', '--1', '.') || '').split('-').map(v=>v||'');

    return (
        <div className={className}>
            <label>
                Certification
                <input placeholder="Certification" type="text" onChange={onChange} value={resolve(data, 'name', '')} name={`${baseKey}.name`} disabled={!active} required={active} />
            </label>
            <label>
                Authority / Institution
                <input placeholder="Authority / Institution" type="text" onChange={onChange} value={resolve(data, 'institution', '')} name={`${baseKey}.institution`} disabled={!active} required={active} />
            </label>
            <label>
                Time Period
                <div className="select-group">
                    <div className="select-group">
                        <select onChange={handleChangeDate} value={start_month} name={`start_month`} disabled={!active} required={active}>
                            <option value="">Month</option>
                            <option value="01">January (01)</option>
                            <option value="02">February (02)</option>
                            <option value="03">March (03)</option>
                            <option value="04">April (04)</option>
                            <option value="05">May (05)</option>
                            <option value="06">June (06)</option>
                            <option value="07">July (07)</option>
                            <option value="08">August (08)</option>
                            <option value="09">September (09)</option>
                            <option value="10">October (10)</option>
                            <option value="11">November (11)</option>
                            <option value="12">December (12)</option>
                        </select>
                        <select onChange={handleChangeDate} value={start_year} name={`start_year`} disabled={!active} required={active}>
                            <option value="">Year</option>
                            { Years }
                        </select>
                    </div>
                    <span>TO</span>
                    <div className="select-group">
                        <select onChange={handleChangeDate} value={finish_month} name={`finish_month`} disabled={!active} required={active}>
                            <option value="">Month</option>
                            <option value="01">January (01)</option>
                            <option value="02">February (02)</option>
                            <option value="03">March (03)</option>
                            <option value="04">April (04)</option>
                            <option value="05">May (05)</option>
                            <option value="06">June (06)</option>
                            <option value="07">July (07)</option>
                            <option value="08">August (08)</option>
                            <option value="09">September (09)</option>
                            <option value="10">October (10)</option>
                            <option value="11">November (11)</option>
                            <option value="12">December (12)</option>
                        </select>
                        <select onChange={handleChangeDate} value={finish_year} name={`finish_year`} disabled={!active} required={active}>
                            <option value="">Year</option>
                            { Years }
                        </select>
                    </div>
                </div>
                <label>
                    Description
                    <textarea placeholder="Certification Description"  onChange={onChange} value={resolve(data, 'description', '')} name={`${baseKey}.description`} disabled={!active} />
                </label>
            </label>
            <div className="resume-builder-fields-controls">
                <span className="a" onClick={() => remove()}>remove</span>
            </div>
        </div>
    )
}

const Certifications = ({ data, handleChange }) => {
    const hasCertifications = resolve(data, 'has_certification', false, '.');

    const onChange = () => {
        handleChange(new SyntheticEvent({
            name: 'has_certification',
            value: !hasCertifications
        }));
    }

    const fieldsClass = [
        "resume-builder-fields",
        !hasCertifications ? 'resume-builder-fields-disabled' : null
    ].filter(c=>c).join(' ')

    return (
        <section className={!hasCertifications ? 'resume-builder-multi-disabled' : ''}>
            <h1><Toggle name="has_certification" checked={hasCertifications} onChange={onChange} /> Certifications <Tag className="tag-auxilary-3">Optional for Resume Creation</Tag></h1>
            <p>
              Have you been trained in a particular skill and have earned a certificate?
            </p>
            <CloneableInputGroup disabled={!hasCertifications} onChange={handleChange} values={data} dataKey="certifications" className="resume-builder-multi">
                <CertificationsFields className={fieldsClass} active={hasCertifications} onChange={handleChange} />
            </CloneableInputGroup>
        </section>
    )
}


export default Certifications;
